'use strict';

export const video = (() => {

    const src_front = 'https://www.youtube.com/embed/';
    const src_back = '?rel=0&amp;enablejsapi=1&amp;origin=*';
    const $player = $('#player');

    /**
     * init
     */
    const init = () => {

        $('.js-play-video').each((index, element) => {
            const $this = $(element);
            const id = $this.data('video-id');

            $this.on('click', event => {
                $player.attr('src', src_front + id + src_back);
                $player.on('load', () => {
                    play();
                });
            });
        });
    };

    const play = () => {
        $player[0].contentWindow.postMessage('{"event": "command", "func": "playVideo", "args": ""}', '*');
    };

    const stop = () => {
        $player[0].contentWindow.postMessage('{"event": "command", "func": "stopVideo", "args": ""}', '*');
    };

    return {
        init: init,
        play: play,
        stop: stop,
        $player: $player
    };
})();
